import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../contextStore/AuthContext';
import { ToastContext } from '../../contextStore/ToastContext';
import { WatchlistContext } from '../../contextStore/WatchlistContext';
import { formatPrice } from '../../utils/formatters';
import './Watchlist.css';

function WatchButton({ productId, productName, currentPrice, product }) {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const { addToWatchlist, removeFromWatchlist, isWatching } =
    useContext(WatchlistContext);
  const { addToast } = useContext(ToastContext);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [alertPrice, setAlertPrice] = useState('');
  const [loading, setLoading] = useState(false);

  const watching = isWatching(productId);
  const price = Number(currentPrice) || 0;

  const handleAdd = () => {
    if (!user) {
      history.push('/login');
      return;
    }
    setShowModal(true);
  };

  const handleRemove = () => {
    if (!user) return;
    setLoading(true);
    removeFromWatchlist(productId)
      .then(() => addToast(t('watchlist.removedFromWatchlist'), 'success'))
      .catch(() => addToast(t('watchlist.failedToRemove'), 'error'))
      .finally(() => setLoading(false));
  };

  const handleSubmitAlert = (e) => {
    e.preventDefault();
    const num = Number(alertPrice);
    if (!num || num <= 0) {
      addToast(t('watchlist.enterValidPrice'), 'error');
      return;
    }
    setLoading(true);
    addToWatchlist(productId, num)
      .then(() => {
        addToast(t('watchlist.priceAlertSet'), 'success');
        setShowModal(false);
        setAlertPrice('');
      })
      .catch(() => addToast(t('watchlist.failedToAdd'), 'error'))
      .finally(() => setLoading(false));
  };

  if (!productId) return null;

  return (
    <>
      {watching ? (
        <button
          type="button"
          className="watchlistBtn watchlistBtnActive"
          onClick={handleRemove}
          disabled={loading}
          title={t('watchlist.removeFromWatchlist')}
        >
          &#128276; {t('watchlist.watching')}
        </button>
      ) : (
        <button
          type="button"
          className="watchlistBtn"
          onClick={handleAdd}
          title={t('watchlist.getPriceDropAlert')}
        >
          {t('watchlist.watch')}
        </button>
      )}
      {showModal && (
        <div className="watchlistOverlay" onClick={() => setShowModal(false)}>
          <div className="watchlistModal" onClick={(e) => e.stopPropagation()}>
            <h3>{t('watchlist.priceDropAlert')}</h3>
            <p className="watchlistModalProduct">{productName}</p>
            <p className="watchlistModalPrice">{t('watchlist.currentPrice')}: {formatPrice(price, product)}</p>
            <form onSubmit={handleSubmitAlert}>
              <label>{t('watchlist.notifyWhenPriceDrops')}</label>
              <input
                type="number"
                min="1"
                value={alertPrice}
                onChange={(e) => setAlertPrice(e.target.value)}
                placeholder={t('watchlist.enterAmount')}
              />
              <div className="watchlistModalActions">
                <button type="button" onClick={() => setShowModal(false)}>
                  {t('common.cancel')}
                </button>
                <button type="submit" disabled={loading}>
                  {loading ? t('watchlist.adding') : t('common.add')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default WatchButton;
